module.exports = __webpack_public_path__ + "h5/img/huodong_6.e55e9f44.jpg";